export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'makhe-theme';

export const THEME_COLORS: Record<Theme, string> = {
  light: '#FCFAFE',
  dark: '#0B0B0F',
};

export function getStoredTheme(): Theme {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY);
    if (value === 'dark') return 'dark';
    if (value === 'light') return 'light';
  } catch {
    /* private mode / blocked storage */
  }
  return 'light';
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.toggle('dark', theme === 'dark');
  root.style.colorScheme = theme;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta) meta.content = THEME_COLORS[theme];
}
